(function(window, mouseButtonsFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.mouseButtons = mouseButtonsFactory();
})(this, function() {
   'use strict';

   return {
      mainButton: 0,
      auxiliaryButton: 1,
      secondaryButton: 2
   };
});
